// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e85bebd0","937":"282e3e10"}[chunkId] + ".chunk.js";
};